// extracted by mini-css-extract-plugin
export default {"section":"FlexTemplate-module__section--BCpX8","subNav":"FlexTemplate-module__subNav--TLgu7","trailingSectionGrid":"FlexTemplate-module__trailingSectionGrid--lWrVg"};